import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { collectWordObjsForStoryMask, MaskedStorySnippet } from "../browse-stories/storyCardMask";
import StoryPlayStoryAccordion from "../story/StoryPlayStoryAccordion";

/**
 * Word-of-day story accordion — puzzle words shown bold + underlined in the text.
 */
export default function WordOfDayStorySection({ presentation, entry }) {
    const wordObjs = useMemo(() => (entry ? collectWordObjsForStoryMask(entry) : []), [entry]);

    if (!presentation) return null;

    const text = String(presentation.text || "").trim();
    const hasContent =
        text || String(presentation.title || "").trim() || String(presentation.imageUrl || "").trim();
    if (!hasContent) return null;

    return (
        <Box sx={{ mb: 2 }}>
            <StoryPlayStoryAccordion
                summaryTitle={presentation.title || undefined}
                imageUrl={presentation.imageUrl || undefined}
                storyId={presentation.storyId ?? undefined}
                showSlidingPuzzle={presentation.showSlidingPuzzle}
                showJigsawPuzzle={presentation.showJigsawPuzzle}
                defaultExpanded
            >
                {text ? (
                    <MaskedStorySnippet
                        text={presentation.text}
                        wordObjs={wordObjs}
                        highlightMode="boldUnderline"
                        component="div"
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.65,
                        }}
                    />
                ) : null}
            </StoryPlayStoryAccordion>
        </Box>
    );
}
